import { Component, OnInit, signal } from '@angular/core';
import { SidebarService } from '@shared/services/sidebar.service';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from '@shared/services/auth.service';
import { NotificationService } from '@shared/services/notification.service';
import { TenantService } from '@core/tenant/tenant.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('portal-zitec');
  isAuthPage = this.computeIsAuthPage(window.location.pathname);

  constructor(
    public sidebarService: SidebarService,
    private translate: TranslateService,
    private router: Router,
    private authService: AuthService,
    private notificationService: NotificationService,
    private tenantService: TenantService
  ) {
    translate.addLangs(['en', 'pt']);
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang?.match(/en|pt/) ? browserLang : 'pt');

    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        this.isAuthPage = this.computeIsAuthPage(e.urlAfterRedirects);
      });
  }

  ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      this.notificationService.startConnection(this.tenantService.getCurrentTenantId());
      this.notificationService.loadAll();
    }
  }

  private computeIsAuthPage(url: string): boolean {
    return url.includes('/auth')
      || url === '/login'
      || url === '/'
      || url.includes('/investor-register')
      || url.includes('/cadastro-investidor')
      || url.includes('/prova-de-vida');
  }
}
